export class mySlips_pObj {
    lastSlipId: number;
    accountNumber: string;
    token: string;
}